import linkedinLogoUrl from '../../images/contact/social-media/linkedin.svg';
import githubLogoUrl from '../../images/contact/social-media/github.svg';
import twitterLogoUrl from '../../images/contact/social-media/twitter.svg';
import mediumLogoUrl from '../../images/contact/social-media/medium.svg';
import devtoLogoUrl from '../../images/contact/social-media/devto.svg';
import stackoverflowLogoUrl from '../../images/contact/social-media/stackoverflow.svg';

const followInfo = [
  {
    imageUrl: linkedinLogoUrl,
    title: 'Linkedin',
    description: 'Meet me on professionals platform.',
    url: 'https://www.linkedin.com/in/amrsaadabdallah',
  },
  {
    imageUrl: githubLogoUrl,
    title: 'Github',
    description: `Let's check my to GitHub repos and Contribute to my open source projects`,
    url: 'https://github.com/amrsaadabdallah',
  },
  {
    imageUrl: twitterLogoUrl,
    title: 'Twitter',
    description: 'Review my tweets',
    url: 'https://twitter.com/amrsaadabdallah',
  },
  {
    imageUrl: mediumLogoUrl,
    title: 'Medium',
    description: 'https://medium.com/@amrsaadabdallah',
    url: 'https://medium.com/@amrsaadabdallah',
  },
  {
    imageUrl: stackoverflowLogoUrl,
    title: 'Stackoverflow',
    description: 'https://stackoverflow.com/users/19376176/amr-saad-abdallah',
    url: 'https://stackoverflow.com/users/19376176/amr-saad-abdallah',
  },
  {
    imageUrl: devtoLogoUrl,
    title: 'Devto',
    description: 'https://dev.to/amrsaadabdallah',
    url: 'https://dev.to/amrsaadabdallah',
  },
];

export default followInfo;
